import axios from "axios"
import CommonServerRoute from "./commonServerRoute"
import { product } from "./commonApi"
import { ApiCall } from "./axios"
import CommonApiEndPoint from "./commonApiEndPoint"
import { collectUtmPayload, getUtmTagsRowIdCookieName } from './utmFieldResolver'

const getUserIpAddress = async () => {
    if (localStorage.getItem('user_ip')) {
        return localStorage.getItem('user_ip')
    } else {
        const user_ip = await axios.get('https://api-bdc.net/data/client-ip').then(response => { return response.data.ipString }).catch(() => '')
        localStorage.setItem('user_ip', user_ip)
        return user_ip
    }
}
function debounce(fn, time) {
    let timer
    return function (...args) {
        clearTimeout(timer)
        timer = setTimeout(() => {
            fn(...args)
        }, time)
    }
}

function getCookie(key) {
    const match = document.cookie.match(new RegExp(`(^| )${key}=([^;]+)`))
    if (match) return match[2]
}

function makeRedirectUrl(res = {}, today_date = '', user_email = {}, redirect_to) {
    // const current_time = Date.parse(new Date(today_date))
    const redirect_url = product[redirect_to]
    const create_url = `${product[redirect_to]}/dashboard`
    return { create_url, redirect_url }
}

function getUrlDomain(productName) {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const myParam = urlParams.get('product')
        const decode_data = productName ? productName : myParam ? myParam : ''
        if ((decode_data === 'app')) {
            return 1
        } else if ((decode_data === 'gst')) {
            return 2
        } else if ((decode_data === 'ecom')) {
            return 4
        } else {
            return 0;
        }
    } catch (error) {

    }
}

function getLoginDomain() {
    try {
        const login_domain = window.location.host
        if (login_domain === CommonServerRoute.live_account) {
            return 1
        } else {
            return 0;
        }
    } catch (error) {

    }
}

/** ME108 / older browsers (e.g. Windows 7) do not support window.location.origin and IE11 does not support window.location.origin in localhost */
function getPageOrigin() {
    if (window.location.origin) {
        return window.location.origin
    }
    const port = window.location.port
    return `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`
}

/**
 * ME77
 * Detect the mobile OS from the user agent.
 * Returns 'ios' | 'android' | null (null = desktop / unknown => no app prompt).
 * NOTE: iPadOS 13+ reports a Mac UA, so we treat touch-capable "Macintosh" as iOS.
 */
const detectMobileOS = () => {
    const ua = navigator.userAgent || ''
    if (/android/i.test(ua)) return 'android'
    if (/iphone|ipad|ipod/i.test(ua)) return 'ios'
    if (/Macintosh/i.test(ua) && typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 1) return 'ios'
    // Desktop site rewrites the UA to a desktop identity. A touch phone screen is still a phone.
    const touch = typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 1
    const coarse = typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches
    const shortSide = Math.min(window.screen?.width || 0, window.screen?.height || 0)
    const hintedPlatform = navigator.userAgentData?.platform || ''
    if (ua.indexOf('Electron') < 0 && touch && coarse && (/android/i.test(hintedPlatform) || (shortSide > 0 && shortSide < 768))) return 'android'
    return null
}

const detectBrowser = () => {
    let user_agent = navigator.userAgent?.toLowerCase()

    let browser = 'Unknown Browser'

    if (user_agent.includes('chrome') || (user_agent.includes('safari') && user_agent.includes('crios'))) {
        browser = 'Chrome'
    }

    if (user_agent.includes("firefox")) {
        browser = "Firefox"
    }

    if (user_agent.includes('safari') && !user_agent.includes('chrome') && !user_agent.includes('crios')) {
        browser = 'Safari'
    }

    if (user_agent.includes('jiosphere')) {
        browser = 'JioSphere'
    }

    if (user_agent.includes('edg/') || user_agent.includes('edge/')) {
        browser = 'Edge'
    }

    if (user_agent.includes('msie')) {
        browser = 'MSIE' //Microsoft Internet Explorer
    }

    if (user_agent.includes('opr/') || user_agent.includes('opera')) {
        browser = 'Opera'
    }

    if (user_agent.includes('lemur')) {
        browser = 'Lemur'
    }

    if (user_agent.includes('samsungbrowser')) {
        browser = 'Samsung Internet'
    }

    if (user_agent.includes('android') && user_agent.includes('wv')) {
        browser = 'Android WebView'
    }

    if (user_agent.includes('googlebot')) {
        browser = 'Google Bot'
    }

    if (user_agent.includes('iemobile')) {
        browser = 'IEMobile'
    }

    if (user_agent.includes('electron')) {
        browser = 'Electron'
    }

    if (navigator.brave) {
        browser = "Brave"
    }
    return browser
}
/**
 * ME108
 * Read marketing cookies for UTM tracking payload.
 * Google:
 * - ga_client_id (_ga)
 * - ga_session_id (_ga_1D0X90J8EV)
 * - gclid (_gcl_aw)
 * - wbraid (_gcl_gb)
 * - gbraid (_gcl_ag)
 * Meta:
 * - fbp (_fbp)
 * - fbc (_fbc)
 */
const getUtmCookiesPayload = () => ({
    ga_client_id: getCookie('_ga') || '',
    ga_session_id: getCookie('_ga_1D0X90J8EV') || '',
    gclid: getCookie('_gcl_aw') || '',
    wbraid: getCookie('_gcl_gb') || '',
    gbraid: getCookie('_gcl_ag') || '',
    fbp: getCookie('_fbp') || '',
    fbc: getCookie('_fbc') || '',
})

const pushRequestOtpEvent = (phone = '') => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: 'RequestOTP',
        user_data: {
            phone: phone || ''
        }
    })
}

/**'0 → Not sure; 1 → Munim web application; 2 → Munim mobile application; 3 → Munim website'; */
const buildSlimUtmApiBody = (utm_page, search = '') => {
    const raw = search || (typeof window !== 'undefined' ? window.location.search : '')
    const normalized = raw.startsWith('?') ? raw : (raw ? `?${raw}` : '')
    const {
        utm_params,
        utm_params_from_url,
        utm_params_from_cookie,
        product_referrer,
        product
    } = collectUtmPayload(normalized, getCookie, getUtmCookiesPayload())
    const data = { utm_page }
    if (Object.keys(utm_params_from_url).length) {
        data.utm_params_from_url = utm_params_from_url
    }
    if (Object.keys(utm_params_from_cookie).length) {
        data.utm_params_from_cookie = utm_params_from_cookie
    }
    if (product_referrer) {
        data.product_referrer = product_referrer
    }
    if (product) {
        data.product = product
    }
    data.insert_from = '1'
    return { data, utm_params, product_referrer }
}

const buildSignupUtmBodyFields = (search = '') => {
    const { data } = buildSlimUtmApiBody('', search)
    delete data.utm_page
    return data
}

const utmMetaTag = async (utm_page, utm_query, utm_source) => {
    try {
        const search = utm_query || (typeof window !== 'undefined' ? window.location.search : '')
        const { data, utm_params } = buildSlimUtmApiBody(utm_page, search)
        const utm_source_label = utm_source || utm_params.utm_source || ''
        const ip_address = await getUserIpAddress()
        const res = await ApiCall("POST", CommonApiEndPoint.utm_meta_tag, data, { ip: ip_address })
        if (res.data.status === 'success') {
            localStorage.setItem('utm_page', utm_page)
            if (utm_source_label) {
                localStorage.setItem('utm_source', utm_source_label)
            }
            if (utm_page === 'login') {
                setCookie(getUtmTagsRowIdCookieName(), res.data.data.id, 1)
            }
        }
    } catch (_error) {
        // UTM meta-tag is best-effort; do not block login/signup
    }
}

/**
 * IW0311
 * if you doing some change in setcookie and getcookie function please do same as well as in ./public/cookie.js file
 */
const setCookie = (name, value, excookie = 30) => {
    const systemDate = new Date()
    systemDate.setTime(systemDate.getTime() + (excookie * 24 * 60 * 60 * 1000))
    const expires = `expires=${systemDate.toUTCString()}`
    document.cookie = `${name}=${value};${expires};path=/; Secure; SameSite=None;`
}

const removeCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
}

export { getUserIpAddress, debounce, getCookie, makeRedirectUrl, getUrlDomain, getLoginDomain, detectBrowser, detectMobileOS, setCookie, removeCookie, pushRequestOtpEvent, utmMetaTag, buildSignupUtmBodyFields, collectUtmPayload, getUtmCookiesPayload, getPageOrigin }
